import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: 'profile/schedule/assign',
  urlRoot: 'profile/schedule/assign',
  only: ['CREATE'],

  state: {
    deals: []
  },

  mutations: {
    updateDealsList(state, deals) {
      state.deals = deals
    }
  },

  actions: {
    async fetchDeals({ commit }, schedule_id) {
      return http.get('/profile/schedule/deals', { 
        params: { schedule_id } 
      })
      .then(res => {
        commit('updateDealsList', res.data)
        return res
      })
    }
  }
})
